/**
 * Sort Event Handlers
 *
 * Handles sort controls: close time sorting with ascending/descending/default cycling
 *
 * @module eventHandlers/sortHandlers
 */

import type { State } from '../types';
import { SORT_FIELDS, DEFAULT_SORT_DIRECTION, persistSortPreference } from '../modules/state';

export interface SortElements {
  sortClose?: HTMLElement;
}

/**
 * Setup sort event handlers
 *
 * @param els - Sort control elements
 * @param state - Application state
 * @param render - Render function
 */
export function setupSortHandlers(els: SortElements, state: State, render: () => void): void {
  if (!els.sortClose) return;

  els.sortClose.addEventListener('click', (event: MouseEvent) => {
    const isCloseSort = state.sort && state.sort.field === SORT_FIELDS.CLOSE;

    if (!isCloseSort) {
      // First click: sort by close time ascending (soonest first)
      state.sort.field = SORT_FIELDS.CLOSE;
      state.sort.direction = DEFAULT_SORT_DIRECTION;
    } else if (state.sort.direction === 'asc' && !(event && event.shiftKey)) {
      // Second click: toggle to descending (furthest first)
      state.sort.direction = 'desc';
    } else {
      // Third click: revert to default updated sort
      state.sort.field = SORT_FIELDS.UPDATED;
      state.sort.direction = 'desc';
    }

    state.page = 1;
    persistSortPreference();
    render();
  });
}
